

import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";
import { IProductionFilter } from "../models/filters/productionFilter";
import { IProductionForm } from "../models/forms/productionForm";
import { IProductionPDTO } from "../models/dtos/productionPDTO";
import ProductionDilutorBathServices from "./ProductionDilutorBathService";
import ProductionSamplingEventService from "./ProductionSamplingEventService";
import ProductionSampleServices from "./ProductionSampleService";
import ProductionAnalyseServices from "./ProductionAnalyseService";
import ProductionStaticServices from "./ProductionStaticService";
import { apiCallWithAuth } from "../helper/apiManager";


export default class ProductionService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/productions";

    protected static override  getUrlFilter<F extends IProductionFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.centerId != undefined)
                url += `&CenterId=${filter.centerId}`;
            if(filter.animalId != undefined)
                url += `&AnimalId=${filter.animalId}`;
            if(filter.dateFrom != undefined)
                url += `&DateFrom=${filter.dateFrom.toISOString()}`;
            // int[] côté back : une occurrence par valeur, comme StockMovementService.
            if(filter.ids != undefined && filter.ids.length > 0)
                filter.ids.forEach(id => url += `&Ids=${id}`);
        }

        return url;
    }

    public static override toDTO(obj:IProductionForm):IProductionPDTO {
        const dto = super.toDTO(obj) as IProductionPDTO;
        dto.dilutorBaths = obj.dilutorBaths.map((item) => {
            return ProductionDilutorBathServices.toDTO(item);
        });
        dto.samplingEvents = obj.samplingEvents.map((item) => {
            return ProductionSamplingEventService.toDTO(item);
        });
        dto.sample = ProductionSampleServices.toDTO( obj.sample);
        dto.analyse = ProductionAnalyseServices.toDTO( obj.analyse);
        dto.static = ProductionStaticServices.toDTO( obj.static);
        return dto;
    }

    public static async destroy(id: number)
    {
        try {
            let result = await apiCallWithAuth(this.mainUrl + "/destroy/" + id, "put");
            return this.ReturnObject(result);
        } catch (err) {
            return this.ReturnError(err);
        }
    }

    /**
     * Retourne les productions d'un animal sur un centre donné (id + ProductionUID + DateProduction).
     * Utilisé par la réception manuelle mono intra pour alimenter la liste des UID prod.
     */
    public static async getByAnimalAndCenter(
        animalId: number, centerId: number,
    ): Promise<{ error: boolean, data: { id: number, productionUID: string, dateProduction: string }[] }> {
        try {
            const result = await apiCallWithAuth(`${this.mainUrl}/by-animal/${animalId}?centerId=${centerId}`);
            return { error: false, data: (result.data as any[]) ?? [] };
        } catch (err: any) {
            return { error: true, data: [] };
        }
    }
}